// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--3Sad1";
export var html = "project-details-module--html--nQ2Yn";
export var image = "project-details-module--image--1atLA";
export var gallery = "project-details-module--gallery--1mq4S";
export var featured = "project-details-module--featured--1zqnC";